import React, { useContext } from 'react';
import Label from '~/componentes/CustomForm/Label';
import { Input, TextArea, Select } from '~/componentes/CustomForm';
import ColoredButton from '~/componentes/Button/Styles/ColoredButton';
import sistemaListStore from '../../../../../../componentes/SistemaList/ThisMainComponent/thisStore';
import { useState } from 'react';
import { useEffect } from 'react';

import { CardAtividade, Container } from './styles';
import IconModalOrcamentoAtividade from '~/assets/icones/modal/IconModalOrcamentoAtividade.svg';
import api from '~/services/api';

function AtividadesList({ defaultData, setter, setterSoma, setterSomaLib, gerarProjeto }) {
  const atividadePad = [
    {
      item: 1,
      id: 0,
      idDesc: '0 - Sem SD',
      abertoAtividade: false,
      titulo: 'Gestão do projeto',
      descricao: '',
      horaTotal: 0,
      horaSaldo: 0,
      horaUsada: 0,
      dataInicioProjeto: '',
      dataPrevEntregaProjeto: '',
      horasPorDia: 8,
      horaInicial: '00:00',
      horaFinal: '00:00',
      dataEntregaProjeto: '',
      travarSaldo: 'S',
      analistas: [],
    },
    {
      item: 2,
      id: 0,
      idDesc: '0 - Sem SD',
      abertoAtividade: false,
      titulo: 'Especificação',
      descricao: '',
      horaTotal: 0,
      horaSaldo: 0,
      horaUsada: 0,
      dataInicioProjeto: '',
      dataPrevEntregaProjeto: '',
      horasPorDia: 8,
      horaInicial: '00:00',
      horaFinal: '00:00',
      dataEntregaProjeto: '',
      travarSaldo: 'S',
      analistas: [],
    },
    {
      item: 3,
      id: 0,
      idDesc: '0 - Sem SD',
      abertoAtividade: false,
      titulo: 'Desenvolvimento',
      descricao: '',
      horaTotal: 0,
      horaSaldo: 0,
      horaUsada: 0,
      dataInicioProjeto: '',
      dataPrevEntregaProjeto: '',
      horasPorDia: 8,
      horaInicial: '00:00',
      horaFinal: '00:00',
      dataEntregaProjeto: '',
      travarSaldo: 'S',
      analistas: [],
    },
    {
      item: 4,
      id: 0,
      idDesc: '0 - Sem SD',
      abertoAtividade: false,
      titulo: 'Validar as rotinas em ambiente de homologação',
      descricao: '',
      horaTotal: 0,
      horaSaldo: 0,
      horaUsada: 0,
      dataInicioProjeto: '',
      dataPrevEntregaProjeto: '',
      horasPorDia: 8,
      horaInicial: '00:00',
      horaFinal: '00:00',
      dataEntregaProjeto: '',
      travarSaldo: 'S',
      analistas: [],
    },
    {
      item: 5,
      id: 0,
      idDesc: '0 - Sem SD',
      abertoAtividade: false,
      titulo: 'Atualizar a base de produção - GoLive',
      descricao: '',
      horaTotal: 0,
      horaSaldo: 0,
      horaUsada: 0,
      dataInicioProjeto: '',
      dataPrevEntregaProjeto: '',
      horasPorDia: 8,
      horaInicial: '00:00',
      horaFinal: '00:00',
      dataEntregaProjeto: '',
      travarSaldo: 'S',
      analistas: [],
    },
    {
      item: 6,
      id: 0,
      idDesc: '0 - Sem SD',
      abertoAtividade: false,
      titulo: 'Acompanhar pós - GoLive',
      descricao: '',
      horaTotal: 0,
      horaSaldo: 0,
      horaUsada: 0,
      dataInicioProjeto: '',
      dataPrevEntregaProjeto: '',
      horasPorDia: 8,
      horaInicial: '00:00',
      horaFinal: '00:00',
      dataEntregaProjeto: '',
      travarSaldo: 'S',
      analistas: [],
    },
    {
      item: 7,
      id: 0,
      idDesc: '0 - Sem SD',
      abertoAtividade: false,
      titulo: 'Reunião de encerramento',
      descricao: '',
      horaTotal: 0,
      horaSaldo: 0,
      horaUsada: 0,
      dataInicioProjeto: '',
      dataPrevEntregaProjeto: '',
      horasPorDia: 8,
      horaInicial: '00:00',
      horaFinal: '00:00',
      dataEntregaProjeto: '',
      travarSaldo: 'S',
      analistas: [],
    },
  ];
  const [atividades, setAtividades] = useState([]);
  const [analistas, setAnalistas] = useState([]);
  const { state } = useContext(sistemaListStore);
  const { edit, editShow } = state?.modal || {};

  useEffect(() => {
    api.get('/signed/empresa/gestorprojeto/gerencia/analistas').then(r => setAnalistas(r?.data));
  }, []);

  useEffect(() => {
    if (Array.isArray(defaultData)) {
      if (defaultData?.length > 0) {
        if (edit) {
          let aAtividade = [];
          let item = 1;
          for (const itemAtividade of defaultData) {
            let analistas = [];

            if (itemAtividade?.itensAtividade && Array.isArray(itemAtividade.itensAtividade)) {
              for (const itemItens of itemAtividade.itensAtividade) {
                analistas.push({
                  id: itemItens?.id,
                  horaTotal: itemItens?.horaTotal,
                  horaSaldo: itemItens?.horaSaldo,
                  horaUsadaMascara: itemItens?.horaUsadaRealMascara,
                  horaUsada: itemItens?.horaUsada,
                  titulo: itemItens?.titulo,
                  descricao: itemItens?.descricao,
                  idAnalista: itemItens?.idAnalista,
                  previsaoInicio: itemItens?.previsaoInicio,
                  dataInicio: itemItens?.dataInicio,
                  previsaoEntrega: itemItens?.previsaoEntrega,
                  dataEntrega: itemItens?.dataEntrega,
                  idProjetoAtividadeAnalista: itemItens?.analistaAtividade?.id,
                });
              }
            }

            // for (const itemAnal of itemAtividade?.analistasAtividade) {
            //   if (!itemAnal?.idProjetoAtividadeItem || itemAnal?.idProjetoAtividadeItem == 0) {
            //     analistas.push({
            //       id: 0,
            //       horaTotal: itemAnal?.horaTotal,
            //       horaSaldo: itemAnal?.horaSaldo,
            //       horaUsada: itemAnal?.horaUsadaReal,
            //       titulo: itemAtividade?.titulo,
            //       descricao: itemAtividade?.descricao,
            //       idAnalista: itemAnal?.idAnalista,
            //       previsaoInicio: itemAtividade?.previsaoInicio,
            //       dataInicio: itemAtividade?.dataInicio,
            //       previsaoEntrega: itemAtividade?.previsaoEntrega,
            //       dataEntrega: itemAtividade?.dataEntrega,
            //       idProjetoAtividadeAnalista: itemAnal?.id,
            //     });
            //   }
            // }

            aAtividade.push({
              item,
              id: itemAtividade?.id,
              idDesc:
                item +
                (itemAtividade?.orcamento ? ` - SD ${itemAtividade?.orcamento?.id}` : ` - Sem SD`),
              titulo: itemAtividade?.titulo,
              descricao: itemAtividade?.descricao,
              horaTotal: itemAtividade?.horaTotal,
              horaSaldo: itemAtividade?.horaSaldo,
              horaUsadaMascara: itemAtividade?.horaUsadaRealMascara,
              horaUsada: itemAtividade?.horaUsadaReal,
              dataInicioProjeto: itemAtividade?.previsaoInicio,
              dataPrevEntregaProjeto: itemAtividade?.previsaoEntrega,
              dataEntregaProjeto: itemAtividade?.dataEntrega,
              horasPorDia: itemAtividade?.horasPorDia,
              horaInicial: itemAtividade?.horaInicial,
              horaFinal: itemAtividade?.horaFinal,
              travarSaldo: itemAtividade?.travarSaldo,
              abertoAtividade: false,
              analistas,
            });

            item++;
          }
          setAtividades(aAtividade);
          setter(aAtividade);
        }
      } else {
        if (!(edit && editShow)) {
          setAtividades(atividadePad);
          setter(atividadePad);
        }
      }
    }
  }, [edit, editShow]);

  useEffect(() => {
    setter(atividades);

    if (setterSoma && setterSomaLib) {
      let horaTotal = 0;
      let horaSaldo = 0;
      for (const item of atividades) {
        horaTotal += item?.horaTotal;
        horaSaldo += item?.horaSaldo;
      }

      setterSoma(horaTotal);
      setterSomaLib(horaSaldo);
    }
  }, [atividades]);

  function handleAddAtividade() {
    setAtividades(prev => [
      ...prev,
      {
        item: atividades?.length > 0 ? atividades[atividades?.length - 1]?.item + 1 : 1,
        id: 0,
        abertoAtividade: false,
        idDesc: '0 - Sem SD',
        titulo: 'Atividade de Projeto',
        descricao: '',
        horaTotal: 0,
        horaSaldo: 0,
        horaUsada: 0,
        dataInicioProjeto: '',
        dataPrevEntregaProjeto: '',
        horasPorDia: 8,
        horaInicial: '00:00',
        horaFinal: '00:00',
        dataEntregaProjeto: '',
        travarSaldo: '',
        analistas: [],
      },
    ]);
  }

  function handleRemoveAtividade(data) {
    setAtividades(prev => {
      const newPrev = [...prev];
      const checkIndex = prev.findIndex(e => e?.item === data?.item);

      if (checkIndex >= 0) {
        newPrev.splice(checkIndex, 1);
      }

      return newPrev;
    });
  }

  function handleAddAnalista(index, atividadePaiData = null) {
    setAtividades(prev => {
      const newPrev = [...prev];
      const analistasAtuais = Array.isArray(newPrev[index]?.analistas)
        ? newPrev[index].analistas
        : [];
      const analistas = [...analistasAtuais];
      const atividadePrincipal = atividadePaiData || newPrev[index] || {};
      const numeroAtividade = Number(atividadePrincipal?.item) || index + 1;
      const numeroSubatividade = analistasAtuais.length + 1;
      const prefixoSubatividade = `Sub ${numeroAtividade}.${numeroSubatividade} - `;
      const tituloBase = (atividadePrincipal?.titulo || newPrev[index]?.titulo || '')
        .replace(/^Sub\s+\d+\.\d+\s*-\s*/i, '')
        .replace(/^Subatividade\s*-\s*/i, '')
        .trim();
      const tituloComPrefixo = `${prefixoSubatividade}${tituloBase}`;

      // newPrev[index].horaTotal = (horaTotal > 0 ? horaTotal : newPrev[index].horaTotal);

      // analistas.push({ id: 0, horaTotal: (analistas.length > 0 ? 0 : newPrev[index].horaTotal), horaSaldo: 0, horaUsada: 0 });

      analistas.push({
        id: 0,
        titulo: tituloComPrefixo,
        descricao: atividadePrincipal?.descricao || '',
        horaTotal: 0,
        horaSaldo: 0,
        horaUsada: 0,
        horaUsadaMascara: '',
        idAnalista: 0,
        previsaoInicio: atividadePrincipal?.dataInicioProjeto || '',
        dataInicio: atividadePrincipal?.dataInicioProjeto || '',
        previsaoEntrega: atividadePrincipal?.dataPrevEntregaProjeto || '',
        dataEntrega: atividadePrincipal?.dataEntregaProjeto || '',
        idProjetoAtividadeAnalista: 0,
      });
      newPrev[index].analistas = analistas;

      return newPrev;
    });
  }

  function handleCopyAtividade(data) {
    setAtividades(prev => {
      const newItem = atividades?.length > 0 ? atividades[atividades?.length - 1]?.item + 1 : 1;

      const copiedAnalistas = data.analistas.map(anal => ({
        id: 0,
        idAnalista: anal.idAnalista,
        titulo: anal.titulo,
        descricao: anal.descricao,
        horaTotal: anal.horaTotal,
        horaSaldo: anal.horaSaldo,
        horaUsada: 0,
        previsaoInicio: '',
        dataInicio: '',
        previsaoEntrega: '',
        dataEntrega: '',
        idProjetoAtividadeAnalista: 0,
      }));

      return [
        ...prev,
        {
          item: newItem,
          id: 0,
          idDesc: '0 - Sem SD',
          abertoAtividade: false,
          titulo: `${data.titulo} (Cópia)`,
          descricao: data.descricao,
          horaTotal: data.horaTotal,
          horaSaldo: data.horaSaldo,
          horaUsada: 0,
          dataInicioProjeto: '',
          dataPrevEntregaProjeto: '',
          dataEntregaProjeto: '',
          horasPorDia: data.horasPorDia,
          horaInicial: data.horaInicial,
          horaFinal: data.horaFinal,
          travarSaldo: data.travarSaldo,
          analistas: copiedAnalistas,
        },
      ];
    });
  }

  function handleRemoveAnalista(index, iAnal) {
    setAtividades(prev => {
      const newPrev = [...prev];
      let analistas = [];
      let count = 0;
      let horaSaldo = 0;

      for (const itemAnal of newPrev[index].analistas) {
        if (count != iAnal) {
          horaSaldo += itemAnal?.horaSaldo;
          analistas.push(itemAnal);
        }

        count++;
      }

      newPrev[index].analistas = analistas;
      // newPrev[index].horaTotal = horaTotal;
      newPrev[index].horaSaldo = horaSaldo;

      return newPrev;
    });
  }

  return (
    <Container>
      <Label title="Atividades *" className="titulo-label" row={true}>
        {!(editShow && edit) ? (
          <ColoredButton small blueLayout type="button" onClick={handleAddAtividade}>
            Adicionar
          </ColoredButton>
        ) : (
          <ColoredButton small disabledLayout type="button">
            Adicionar
          </ColoredButton>
        )}
      </Label>
      {/* {atividades?.map((itemData, index) => ( */}
      <CardAtividade>
        {/* <div className="card-atv-header">
            <div className="titulo">
              <div className="fundo-icon">
                <img className="atividade" src={IconModalOrcamentoAtividade} alt="Vazio" />
              </div>
              <p className="item">Item {itemData?.idDesc} </p>
            </div>
            <div onClick={(e) => { handleRemoveAtividade(itemData) }} className="icon-button material-icons">delete</div>
          </div>
          <div className="card-atv-body">
            <div className="row no-margin row-top">
              <Label title="Titulo da Atividade * " className="col s12 m12 l4">
                <Input
                  placeholder="Titulo da Atividade"
                  name="tituloAtividadeAt"
                  required="true"
                  value={itemData?.titulo}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "";
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].titulo = v;

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="Data Inicio " className="col s12 m6 l2">
                <Input
                  type="date"
                  name="dataInicioProjetoAt"
                  value={itemData?.dataInicioProjeto}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].dataInicioProjeto = v;

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="Data P/ Entrega " className="col s12 m6 l2">
                <Input
                  type="date"
                  name="dataPrevEntregaProjetoAt"
                  value={itemData?.dataPrevEntregaProjeto}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].dataPrevEntregaProjeto = v;

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="Data de Entrega " className="col s12 m6 l2">
                <Input
                  type="date"
                  name="dataEntregaProjetoAt"
                  value={itemData?.dataEntregaProjeto}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].dataEntregaProjeto = v;

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="Travar OS P/ saldo *" className="col s12 m6 l2">
                <Select
                  required="true"
                  isString
                  list={{ list: [{ id: "S", titulo: "Sim" }, { id: "N", titulo: "Não" }], value: "id", label: "titulo" }}
                  name="travarSaldo"
                  value={itemData?.travarSaldo}
                  disabled="true"
                  // onChange={(e) => {
                  //   const v = e.currentTarget.value || 0;
                  //   setAtividades((prev) => {
                  //     let newPrev = [...prev];

                  //     newPrev[index].travarSaldo = v;

                  //     return newPrev;
                  //   });
                  // }}
                />
              </Label>
            </div>
            <div className="row no-margin">
              <Label title="Hora Total * " className="col s12 m6 l2">
                <Input
                  type="number"
                  name="horaTotalAt"
                  min="1"
                  required="true"
                  value={itemData?.horaTotal}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].horaTotal = parseInt(v);

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="HR Lib Analistas * " className="col s12 m6 l2">
                <Input
                  type="number"
                  name="horaSaldoAt"
                  step="0.10"
                  required="true"
                  readOnly="true"
                  value={itemData?.horaSaldo}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].horaSaldo = parseFloat(v);

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="Horas Usada * " className="col s12 m6 l2">
                <Input
                  type="number"
                  name="horaUsadaAt"
                  step="0.10"
                  required="true"
                  disabled="true"
                  value={itemData?.horaUsada}
                />
              </Label>
              <Label title="Horas Por Dia * " className="col s12 m6 l2">
                <Input
                  type="number"
                  name="horasPorDiaAt"
                  min="1"
                  max="24"
                  required="true"
                  value={itemData?.horasPorDia}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].horasPorDia = parseInt(v);

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="Hora Inicial " className="col s12 m6 l2">
                <Input
                  type="time"
                  name="horaInicialAt"
                  value={itemData?.horaInicial}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].horaInicial = v;

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="Hora Final " className="col s12 m6 l2">
                <Input
                  type="time"
                  name="horaFinalAt"
                  value={itemData?.horaFinal}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].horaFinal = v;

                      return newPrev;
                    });
                  }}
                />
              </Label>
            </div>
            <div className="row no-margin">
              <div className="col s12 m12 l6">
                <TextArea
                  placeholder="Descrição da Atividade"
                  name="descAtividadeAt"
                  value={itemData?.descricao}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "";
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].descricao = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="col s12 m12 l6">
                <Label title="Analistas" className="titulo-label no-margin" row={true}>
                  {!(editShow && edit) ? (
                    <ColoredButton small blueLayout type="button" onClick={() => { handleAddAnalista(index) }}>
                      Adicionar
                    </ColoredButton>
                  ) : (
                    <ColoredButton small disabledLayout type="button">
                      Adicionar
                    </ColoredButton>
                  )}
                </Label>
                <div className="list-analista">
                  {itemData?.analistas?.map((itemAnal, iAnal) => (
                    <div className="item-analista">
                      <div className="col s12 m6 l4 padding-right">
                        {itemAnal?.id == 0 ? (<div onClick={(e) => { handleRemoveAnalista(index, iAnal) }} className="icon-button material-icons">delete</div>) : <div />}
                        <Select
                          isString
                          list={{ list: analistas, value: "id", label: "nome" }}
                          name={"idAnalista" + iAnal}
                          firstOption
                          required="true"
                          {...{ ...(itemAnal?.id == 0 ? {} : { disabled: true }) }}
                          onChange={(e) => {
                            const v = e.currentTarget.value || 0;
                            setAtividades((prev) => {
                              const newPrev = [...prev];
                              let analistas = [];
                              let count = 0;

                              for (const itemAnal of newPrev[index].analistas) {
                                if (count == iAnal) {
                                  analistas.push({ ...itemAnal, idAnalista: parseInt(v) });
                                } else {
                                  analistas.push(itemAnal);
                                }

                                count++;
                              }
                              newPrev[index].analistas = analistas;

                              return newPrev;
                            });
                          }}
                          value={itemAnal?.idAnalista}
                        />
                      </div>
                      <div className="col s12 m6 l4 padding-right">
                        <p>Hr Lib Analista</p>
                        <Input
                          type="number"
                          name={"horaSaldo" + iAnal}
                          step="0.10"
                          required="true"
                          value={itemAnal?.horaSaldo}
                          onChange={(e) => {
                            const v = e.currentTarget.value || 0;
                            setAtividades((prev) => {
                              const newPrev = [...prev];
                              let analistas = [];
                              let count = 0;
                              let horaSaldo = 0;

                              for (const itemAnal of newPrev[index].analistas) {
                                if (count == iAnal) {
                                  horaSaldo += parseInt(v);
                                  analistas.push({ ...itemAnal, horaSaldo: parseInt(v) });
                                } else {
                                  horaSaldo += itemAnal?.horaSaldo;
                                  analistas.push(itemAnal);
                                }

                                count++;
                              }
                              newPrev[index].analistas = analistas;
                              newPrev[index].horaSaldo = horaSaldo;

                              return newPrev;
                            });
                          }}
                        />
                      </div>
                      <div className="col s12 m6 l4">
                        <p>Hora Usada</p>
                        <Input
                          type="number"
                          name={"horaUsada" + iAnal}
                          min="1"
                          required="true"
                          disabled="true"
                          value={itemAnal?.horaUsada}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div> */}
        <div className="card-atv-header">
          <div className="titulos-tab">
            <div className="w1">
              <div className="top-header">-</div>
            </div>
            <div className="atividade">
              <p className="titulo">
                Título Atividade <span>*</span>
              </p>
            </div>
            <div className="data-prev-inicio">
              <p className="titulo">
                Data Prev Inicio <span>*</span>
              </p>
            </div>
            <div className="data-prev-entrega">
              <p className="titulo">
                Data Prev Entrega <span>*</span>
              </p>
            </div>
            <div className="data-entrega">
              <p className="titulo">
                Data Entrega <span>*</span>
              </p>
            </div>
            <div className="hora-total">
              <p className="titulo">
                Hora Total <span>*</span>
              </p>
            </div>
            <div className="hora-lib">
              <p className="titulo">
                Hora Lib Analista <span>*</span>
              </p>
            </div>
            <div className="hora-lib">
              <p className="titulo">
                Hora Usada <span>*</span>
              </p>
            </div>
            <div className="trav-os">
              <p className="titulo">
                Travar OS P/ saldo <span>*</span>
              </p>
            </div>
            <div className="hora-dia">
              <p className="titulo">
                Horas Por Dia <span>*</span>
              </p>
            </div>
            <div className="hora-inicial">
              <p className="titulo">Horas Inicial</p>
            </div>
            <div className="hora-final">
              <p className="titulo">Horas Final</p>
            </div>
            <div className="desc">
              <p className="titulo">Descrição</p>
            </div>
          </div>
        </div>

        {atividades?.map((itemData, index) => (
          <div key={itemData?.item || index} className="card-atv-body">
            <div className="row no-margin row-top">
              <div className="w1">
                <div className="top-header">
                  <div
                    onClick={() => {
                      handleRemoveAtividade(itemData);
                    }}
                    className="icon-button material-icons"
                  >
                    delete
                  </div>
                  <div
                    onClick={() => {
                      handleCopyAtividade(itemData);
                    }}
                    className="icon-button material-icons"
                    title="Copiar atividade"
                  >
                    content_copy
                  </div>
                  <div
                    onClick={() => {
                      setAtividades(prev => {
                        let newPrev = [...prev];

                        newPrev[index].abertoAtividade = !newPrev[index].abertoAtividade;

                        return newPrev;
                      });
                    }}
                    className="icon-button material-icons"
                  >
                    description
                  </div>
                </div>
              </div>
              <div className="w2">
                <Input
                  placeholder="Titulo da Atividade"
                  name="tituloAtividadeAt"
                  required="true"
                  value={itemData?.titulo}
                  onChange={e => {
                    const v = e.currentTarget.value || '';
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].titulo = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w3">
                <Input
                  type="date"
                  name="dataInicioProjetoAt"
                  value={itemData?.dataInicioProjeto}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].dataInicioProjeto = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w3">
                <Input
                  type="date"
                  name="dataPrevEntregaProjetoAt"
                  min={itemData?.dataInicioProjeto}
                  value={itemData?.dataPrevEntregaProjeto}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].dataPrevEntregaProjeto = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w3">
                <Input
                  type="date"
                  name="dataEntregaProjetoAt"
                  value={itemData?.dataEntregaProjeto}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].dataEntregaProjeto = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w3">
                <Input
                  type="number"
                  name="horaTotalAt"
                  min="1"
                  required="true"
                  value={itemData?.horaTotal}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].horaTotal = parseInt(v);

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w3">
                <Input
                  type="number"
                  name="horaSaldoAt"
                  step="0.10"
                  required="true"
                  disabled="true"
                  value={itemData?.horaSaldo}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].horaSaldo = parseFloat(v);

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w3">
                <Input
                  type="string"
                  name="horaUsadaAt"
                  // step="0.10"
                  required="true"
                  disabled="true"
                  value={itemData?.horaUsadaMascara}
                />
              </div>
              <div className="w3">
                <Select
                  required="true"
                  isString
                  list={{
                    list: [
                      { id: 'S', titulo: 'Sim' },
                      { id: 'N', titulo: 'Não' },
                    ],
                    value: 'id',
                    label: 'titulo',
                  }}
                  name="travarSaldo"
                  value={itemData?.travarSaldo}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].travarSaldo = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w4">
                <Input
                  type="number"
                  name="horasPorDiaAt"
                  min="1"
                  max="24"
                  required="true"
                  value={itemData?.horasPorDia}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].horasPorDia = parseInt(v);

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w4">
                <Input
                  type="time"
                  name="horaInicialAt"
                  value={itemData?.horaInicial}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].horaInicial = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w4">
                <Input
                  type="time"
                  name="horaFinalAt"
                  value={itemData?.horaFinal}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].horaFinal = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w5">
                <TextArea
                  placeholder="Descrição da Atividade"
                  name="descAtividadeAt"
                  value={itemData?.descricao}
                  onChange={e => {
                    const v = e.currentTarget.value || '';
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].descricao = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
            </div>

            {itemData?.abertoAtividade && (
              <div className="sub-atividade">
                <div className="card-sub-atv-header">
                  <div className="titulos-tab">
                    <div className="w1">
                      <div className="add-header">
                        {!(editShow && edit) ? (
                          <ColoredButton
                            small
                            blueLayout
                            type="button"
                            onClick={() => {
                              handleAddAnalista(index, itemData);
                            }}
                          >
                            +
                          </ColoredButton>
                        ) : (
                          <ColoredButton small disabledLayout type="button">
                            +
                          </ColoredButton>
                        )}
                      </div>
                    </div>
                    <div className="atividade">
                      <p className="titulo">
                        Título Tarefa <span>*</span>
                      </p>
                    </div>
                    <div className="hora-lib">
                      <p className="titulo">
                        Hora Lib <span>*</span>
                      </p>
                    </div>
                    <div className="hora-lib">
                      <p className="titulo">
                        Hora Usada <span>*</span>
                      </p>
                    </div>
                    <div className="hora-final">
                      <p className="titulo">
                        Analista <span>*</span>
                      </p>
                    </div>
                    <div className="data-prev-inicio">
                      <p className="titulo">
                        Prev Inicio <span>*</span>
                      </p>
                    </div>
                    <div className="data-prev-entrega">
                      <p className="titulo">
                        Prev Entrega <span>*</span>
                      </p>
                    </div>
                    <div className="data-entrega">
                      <p className="titulo">Data Entrega</p>
                    </div>
                    <div className="desc">
                      <p className="titulo">Descrição</p>
                    </div>
                  </div>
                </div>

                {itemData?.analistas?.map((itemAtividade, indexAtividade) => (
                  <div key={itemAtividade?.id || indexAtividade} className="row no-margin row-top">
                    <div className="w1">
                      <div className="top-header">
                        {itemAtividade?.horaUsadaReal == 0 || !itemAtividade?.horaUsadaReal ? (
                          <div
                            onClick={() => {
                              handleRemoveAnalista(index, indexAtividade);
                            }}
                            className="icon-button material-icons"
                          >
                            delete
                          </div>
                        ) : (
                          <div />
                        )}
                      </div>
                    </div>
                    <div className="w2">
                      <Input
                        placeholder="Titulo da Tarefa"
                        name="tituloTarefaAt"
                        required="true"
                        value={itemAtividade?.titulo}
                        {...{
                          ...(itemAtividade?.id == 0 &&
                          itemAtividade?.idProjetoAtividadeAnalista != 0
                            ? { disabled: true }
                            : {}),
                        }}
                        onChange={e => {
                          const v = e.currentTarget.value || '';
                          setAtividades(prev => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index].analistas || []) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, titulo: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="w3">
                      <Input
                        type="number"
                        name="horaSaldoTarefaAt"
                        step="0.10"
                        required="true"
                        value={itemAtividade?.horaSaldo}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setAtividades(prev => {
                            const newPrev = [...prev];
                            let analistas = [];
                            let count = 0;
                            let horaSaldo = 0;

                            for (const itemAnal of newPrev[index].analistas || []) {
                              if (count == indexAtividade) {
                                horaSaldo += parseInt(v);
                                analistas.push({ ...itemAnal, horaSaldo: parseInt(v) });
                              } else {
                                horaSaldo += itemAnal?.horaSaldo;
                                analistas.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = analistas;
                            newPrev[index].horaSaldo = horaSaldo;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="w3">
                      <Input
                        type="string"
                        name="horaUsadaTarefaAt"
                        // step="0.10"
                        // required="true"
                        disabled="true"
                        value={itemAtividade?.horaUsadaMascara}
                      />
                    </div>
                    <div className="w4">
                      <Select
                        isString
                        list={{ list: analistas, value: 'id', label: 'nome' }}
                        name={'idAnalista' + indexAtividade}
                        firstOption
                        required="true"
                        {...{
                          ...(itemAtividade?.idProjetoAtividadeAnalista == 0
                            ? {}
                            : { disabled: true }),
                        }}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setAtividades(prev => {
                            const newPrev = [...prev];
                            let analistas = [];
                            let count = 0;

                            for (const itemAtividade of newPrev[index].analistas || []) {
                              if (count == indexAtividade) {
                                analistas.push({ ...itemAtividade, idAnalista: parseInt(v) });
                              } else {
                                analistas.push(itemAtividade);
                              }

                              count++;
                            }
                            newPrev[index].analistas = analistas;

                            return newPrev;
                          });
                        }}
                        value={itemAtividade?.idAnalista}
                      />
                    </div>
                    <div className="w3">
                      <Input
                        type="date"
                        name="previsaoInicioTarefaAt"
                        value={itemAtividade?.previsaoInicio}
                        min={itemData?.previsaoInicioProjeto}
                        max={itemData?.dataPrevEntregaProjeto}
                        {...{
                          ...(itemAtividade?.id == 0 &&
                          itemAtividade?.idProjetoAtividadeAnalista != 0
                            ? { disabled: true }
                            : {}),
                        }}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setAtividades(prev => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index].analistas || []) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, previsaoInicio: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="w3">
                      <Input
                        type="date"
                        name="previsaoEntregaTarefaAt"
                        value={itemAtividade?.previsaoEntrega}
                        min={itemAtividade?.previsaoInicio}
                        max={itemData?.dataPrevEntregaProjeto}
                        {...{
                          ...(itemAtividade?.id == 0 &&
                          itemAtividade?.idProjetoAtividadeAnalista != 0
                            ? { disabled: true }
                            : {}),
                        }}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setAtividades(prev => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index].analistas || []) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, previsaoEntrega: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="w3">
                      <Input
                        type="date"
                        name="dataEntregaTarefaAt"
                        value={itemAtividade?.dataEntrega}
                        {...{
                          ...(itemAtividade?.id == 0 &&
                          itemAtividade?.idProjetoAtividadeAnalista != 0
                            ? { disabled: true }
                            : {}),
                        }}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setAtividades(prev => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index].analistas || []) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, dataEntrega: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                    <div className="w5">
                      <TextArea
                        placeholder="Descrição da Atividade"
                        name="descricaoTarefaAt"
                        value={itemAtividade?.descricao}
                        {...{
                          ...(itemAtividade?.id == 0 &&
                          itemAtividade?.idProjetoAtividadeAnalista != 0
                            ? { disabled: true }
                            : {}),
                        }}
                        onChange={e => {
                          const v = e.currentTarget.value || '';
                          setAtividades(prev => {
                            let newPrev = [...prev];

                            let listaItens = [];
                            let count = 0;
                            for (const itemAnal of newPrev[index].analistas || []) {
                              if (count == indexAtividade) {
                                listaItens.push({ ...itemAnal, descricao: v });
                              } else {
                                listaItens.push(itemAnal);
                              }

                              count++;
                            }
                            newPrev[index].analistas = listaItens;

                            return newPrev;
                          });
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </CardAtividade>
      {/* ))} */}
    </Container>
  );
}

export default AtividadesList;
